import React, { useContext } from 'react';
import RequestContext from 'components/wizard/context/request/context';

export const useRequest = () => {
  return useContext(RequestContext);
};
